// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageWrapper-module_pageWrapper__Iuel3 {
    display: flex;
    flex-direction: column;
    flex: 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/common/pageWrapper.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX","sourcesContent":[".pageWrapper {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `pageWrapper-module_pageWrapper__Iuel3`
};
export default ___CSS_LOADER_EXPORT___;
